import { Fragment, type ReactNode } from 'react'

/**
 * Place elements — a link, a bold name — inside a translated sentence.
 *
 * `t()` leaves a `{name}` with no matching variable untouched, so a sentence
 * like "By clicking join, you agree to our {terms} and {privacy}." can be
 * translated whole, word order and all, and the links dropped in afterwards.
 * Building it from fragments instead ("you agree to our" + link + "and" + …)
 * fixes the English word order on every language.
 */
export function fillSlots(text: string, slots: Record<string, ReactNode>): ReactNode[] {
  return text.split(/\{(\w+)\}/).map((part, i) =>
    i % 2 === 1
      ? <Fragment key={i}>{part in slots ? slots[part] : `{${part}}`}</Fragment>
      : part,
  )
}
